import { render, staticRenderFns } from "./all_risks.vue?vue&type=template&id=06f05cf2"
import script from "./all_risks.vue?vue&type=script&lang=js"
export * from "./all_risks.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports